import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { getOrderAcknowledgementPdf, PdfResultModel } from "@WhiteCap/Services/GetOrderDetailsPdfService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";

export interface getOrderAcknowledgementPdfApiParameter extends ApiParameter {
    orderNumber: string;
    isOrderHistoryDetailsPage: boolean;
    onSuccess?: () => void;
    onError?: (message: string) => void;
}

type HandlerType = CustomApiHandler<getOrderAcknowledgementPdfApiParameter, PdfResultModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};
export const RequestDataFromApi: HandlerType = async props => {
    const result = await getOrderAcknowledgementPdf(props.apiParameter.orderNumber, props.apiParameter.isOrderHistoryDetailsPage);
    if (!result.successful) {
        props.parameter.onError?.(result.errorMessage);
        return false;
    }
    if (result.result) {
        props.apiResult = result;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.result) {
        const blob = new Blob([props.apiResult.result], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Order Acknowledgement-${props.apiParameter.orderNumber}.pdf`);
        link.click();

        // Revoke URL after a short delay to allow the download to complete
        setTimeout(() => {
            window.URL.revokeObjectURL(url);
        }, 100);

        if (props.parameter?.onSuccess) {
            props.parameter.onSuccess();
        }
    }
};
export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];
const getOrderAcknowledgementPdfHandler = createHandlerChainRunner(chain, "GetOrderAcknowledgementPdfHandler");
export default getOrderAcknowledgementPdfHandler;
